<template>
  <div class="main">
    <div class="title">
<!--      <div class="name" v-if="Number(stateNum) === 2">已拒绝专家基本信息</div>-->
      <div class="name" >专家预约</div>
      <div class="btn" @click="back">
        <img src="../../../assets/images/back.png" alt="">
        返回
      </div>
    </div>
    <div class="form-box">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="detailId ? true : false" label-width="100px" class="demo-ruleForm">

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="project_name">
              <el-autocomplete
                style="width: 100%;"
                class="inline-input"
                v-model="ruleForm.project_name"
                :fetch-suggestions="querySearch"
                placeholder="请输入"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动主题" prop="event_theme">
              <el-input v-model="ruleForm.event_theme"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="时间" prop="time">
              <el-date-picker
                  v-model="ruleForm.time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="天数" prop="day_typy">
              <el-select v-model="ruleForm.day_typy" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in day_options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="劳务费类别" prop="fees_type">
              <el-select v-model="ruleForm.fees_type" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in type_options"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="劳务金额" prop="fees">
              <el-input v-model="ruleForm.fees"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <div class="flex justify-center align-center">
            <span class="btn1" v-if="id" @click="submitForm('ruleForm')">提交</span>
            <a class="btn3" v-else :href="baseURL + '/api/yuyue/exportToLaowufei?mid=' + user.mid+ '&id='+ detailId" target="_blank" download>导出劳务费申请单</a>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <evaluateDialog :dialogVisible="dialogVisible" :pjId="pjId" :item="{}" @handleClose="handleClose" />
  </div>
</template>
<script>

import {
  getYuyueProjectName,
  getYuyueDay,
  getYuyueFeesType, internalYuyue,internalDetail
} from "@/api/index";
import {baseURL, fileUpUrl, urlStr} from '@/config/index'
import evaluateDialog  from "@/views/home/common/evaluateDialog";
export default {
  name: "examine-detail",
  data() {
    return {
      id:'', // 专家ID
      pjId:'', // 未评价预约 ID
      dialogVisible:false,
      detailId:'',
      fileUpUrl: fileUpUrl,
      urlStr: urlStr,
      baseURL: baseURL,
      requestData: {type: 2},//1图片2文件
      ruleForm: {
        name:'',
        phone:'',
        project_name:'',
        event_theme:'',
        time:'',
        day_typy:'',
        fees_type:'',
        fees:'',
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
         ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        event_theme: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        project_name: [
          { required: true, message: '请输入', trigger: 'change' },
        ],
        time: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        day_typy: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        fees_type: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        fees: [
          { required: true, message: '请输入', trigger: 'change' },
        ],

      },
      project_options:[],
      day_options:[],
      type_options:[],
      create_time:'',
      state_remark:'',
      stateNum: 0,
      act:''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {evaluateDialog},
  created() {
    this.ruleForm.name = this.user.name
    this.ruleForm.phone = this.user.phone
    this.id = this.$route.query.id
    this.detailId = this.$route.query.detailId
    this.$emit("setActive", {
      active: 1,
      act: 2,
      name: `专家管理 > 专家信息 > 专家预约`
    })
    this.getYuyueProjectName()
    this.getYuyueDay()
    this.getYuyueFeesType()
    if(this.detailId){
      this.init()
    }
  },
  methods: {

    handleClose(){
      this.dialogVisible = false
      // if(data) {
      //   this.sub()
      // }
    },

    async init(){
      let _data = await internalDetail(this.user.mid,this.detailId);
      if(_data.status == 200) {
        this.ruleForm =  {
          name: _data.data.name,
          phone: _data.data.phone,
          project_name:_data.data.project_name,
          event_theme: _data.data.event_theme,
          time: _data.data.time,
          day_typy: _data.data.day_typy,
          fees_type: _data.data.fees_type,
          fees: _data.data.fees,
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          this.$message.error('请填写完整');
          return false;
        }
      });
    },

    // 获取内部预约项目名称
    async getYuyueProjectName(){
      let _res = await getYuyueProjectName(
          this.user.mid
      );
      if(_res.status === 200){
        this.project_options = _res.data
        this.project_options.map(item => {
          item.value = item.project_name
        })
      }else {
        this.$message.error(_res.msg);
      }
    },
    // 获取内部预约天数
    async getYuyueDay(){
      let _res = await getYuyueDay(
        this.user.mid
      );
      if(_res.status === 200){
        this.day_options = _res.data
      }else {
        this.$message.error(_res.msg);
      }
    },
    // 获取内部预约劳务费类别
    async getYuyueFeesType(){
      let _res = await getYuyueFeesType(
        this.user.mid
      );
      if(_res.status === 200){
        this.type_options = _res.data
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 提交信息
    async sub(){
      let _res = await internalYuyue(
          this.user.mid,
          this.id,
          this.ruleForm.name,
          this.ruleForm.phone,
          this.ruleForm.project_name,
          this.ruleForm.event_theme,
          this.ruleForm.time,
          this.ruleForm.day_typy,
          this.ruleForm.fees_type,
          this.ruleForm.fees,
      );
      if(_res.status === 200){
        // this.$message.success(_res.msg);
        this.$confirm('预约成功，是否导出劳务费申请单?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportToLaowufei(Number(_res.data.id))
        }).catch(() => {
          this.back()
        });
      }else if(_res.status === 110){
        this.$message.error(_res.msg);
        this.pjId = _res.data.id
        this.dialogVisible = true
      }else {
        this.$message.error(_res.msg);
      }
    },

    async exportToLaowufei(id) {
      let url = this.baseURL + '/api/yuyue/exportToLaowufei?mid=' + this.user.mid+ '&id='+ id;
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.download = '劳务费申请单';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    back(){
      this.$router.back()
    },
    querySearch(queryString, cb) {
      var restaurants = this.project_options;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
      };
    }
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.add {
  width: 70px;
  height: 40px;
  border: 1px solid #dcdfe6;
  color: #606266;
  font-size: 14px;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  border-radius: 4px;
  margin-left: 5px;
  padding: 0;
}
.btn1 {
  width: 120px;
  height: 40px;
  background-color: #0a2240;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  margin: 0 15px;
}
.btn2 {
  width: 120px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 20px;
  border: solid 1px #0a2240;
  font-size: 14px;
  color: #0a2240;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
  margin: 0 15px;
}
.btn3 {
  width: 150px;
  height: 40px;
  background-color: #ff9600;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  margin: 0 15px;
}
.img-box {
  width: 125px;
  max-height: 164px;
  border-radius: 10px;
  border: 1px solid #0a2240;
  position: relative;
  //overflow: hidden;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: scale-down;
  }
  .upload-demo {
    width: 100%;
    height: 100%;
  }
  .moren {
    display: block;
    line-height: 30px;
    font-size: 12px;
    background-color: #0a2240;
    color: #ffffff;
    width: 125px;
    text-align: center;
    border-radius: 3px;
    position: absolute;
    bottom: -36px;
    right: 0;
    z-index: 300;
    cursor: pointer;
  }
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
    .btn {
      width: 100px;
      height: 40px;
      background-color: #ffffff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      letter-spacing: 1px;
      color: #0a2240;
      cursor: pointer;
      img {
        width: 14px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }
  .form-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 12px;
    flex: 1;
    .detail-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 20px;
      p {
        width: 601px;
        padding: 14px;
        background-color: #dae0e6;
        border-radius: 10px;
        border: solid 1px #dae0e6;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 14px;
        color: #333333;
      }
    }
  }
}
</style>


